<template>
  <div class="pure-g">
    <div class="pure-u-md-1-5 pure-u-lg-1-4"></div>
    <div class="pure-u-1 pure-u-md-3-5 pure-u-lg-1-2">
      <div class="content box padding-30-reactive">
        <div class="text-center">
          <img class="cycle-benefactors-club-success-image" src="../../assets/images/CycleBenefactorsClubLogo.png">
        </div>
        <p>
          Keep an eye on your inbox! Great beer coming to you soon!
        </p>
        <p>
          If you have any questions, concerns or comments, please email
          <a href="mailto:support@tavour.com">support@tavour.com</a>.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../../lib/store';

export default {
  name: 'SuccessCycleBenefactorsClub',
  created() {
    /* global ga */
    ga('send', 'pageview', `/${store.get('cycleBenefactorsClub')}/Success`);

    store.clear();
  },
};
</script>

<style scoped>
  .cycle-benefactors-club-success-image {
    height: 160px;
    width: auto;
    margin-bottom: 15px;
  }
</style>



// WEBPACK FOOTER //
// SuccessCycleBenefactorsClub.vue?1a868ac9